import { reversalList } from "@/mocks/events";
import { Reveal, SectionHead } from "./ui";

export default function Reversal() {
  return (
    <section id="reversal" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          index="03"
          en="Plot Twist"
          title="反转专区 · 剧情重写"
          desc="很多瓜吃到一半就反转了。我们把“此前传闻”和“最新实情”并排放一起，帮你一眼看清风波到底转向了哪里。"
        />

        <div className="flex flex-col gap-6">
          {reversalList.map((r, idx) => (
            <Reveal key={r.id} delay={idx * 90}>
              <article className="group grid grid-cols-1 gap-0 overflow-hidden rounded-2xl border border-background-200 bg-background-100/50 lg:grid-cols-5 lg:items-stretch">
                {/* image */}
                <div className="relative h-56 w-full overflow-hidden lg:col-span-2 lg:h-auto">
                  <img
                    src={r.image}
                    alt={`${r.title}反转前后配图`}
                    title={`吃瓜前线 - ${r.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    <i className="ri-restart-line" aria-hidden="true"></i>
                    {r.category}
                  </span>
                </div>

                {/* content */}
                <div className="flex flex-col p-5 md:p-6 lg:col-span-3 lg:p-7">
                  <div className="flex flex-wrap items-start justify-between gap-2">
                    <h3 className="max-w-[80%] font-heading text-base font-bold leading-snug text-foreground-950 md:text-[19px]">
                      {r.title}
                    </h3>
                    <span className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
                      {r.rate}
                    </span>
                  </div>

                  <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <div className="rounded-xl bg-background-50 p-4 ring-1 ring-background-200">
                      <p className="mb-2 flex items-center gap-1.5 text-xs font-bold text-secondary-500">
                        <i className="ri-error-warning-line" aria-hidden="true"></i>
                        此前传闻
                      </p>
                      <p className="text-[13px] leading-6 text-foreground-600">{r.before}</p>
                    </div>
                    <div className="rounded-xl bg-primary-50 p-4 ring-1 ring-primary-200">
                      <p className="mb-2 flex items-center gap-1.5 text-xs font-bold text-primary-700">
                        <i className="ri-check-double-line" aria-hidden="true"></i>
                        最新实情
                      </p>
                      <p className="text-[13px] leading-6 text-foreground-800">{r.after}</p>
                    </div>
                  </div>

                  <span className="mt-4 flex items-center gap-1.5 self-start whitespace-nowrap text-xs font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                    查看完整反转时间线
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}